<div class="login-wrapper d-flex">
    <div class="login-wrapper__inner">
        <section class="left-panel">
            <div class="left-panel--top">
                <img src="assets/images/upgradRed/upgradEntLoginLogo.png" alt="Logo" />
                <p>The Learning Institute of choice For Professionals </p>
            </div>
            <div class="left-panel--image">
                <img src="assets/images/upgradRed/upgradLoginPeopleLogo.png" alt="" />
            </div>
        </section>
        <section class="right-panel">
            <div class="right-panel__logo">
                <div *ngIf="!isPasswordForgot && !isSSOPartner && !isMultipleLogin">
                    <h2>Login</h2>
                    <p>You are accessing upGrad Enterprise as a part of your institution/ organization.</p>
                </div>
                <div *ngIf="isPasswordForgot">
                    <h2>Forgot your password</h2>
                    <p>We'll send a reset link to your registered mail</p>
                </div>
                <div *ngIf="isSSOPartner">
                    <h2>Sign In Via <span>SSO</span></h2>
                    <p>Please enter your SSO company ID</p>
                </div>
                <div *ngIf="isMultipleLogin">
                    <h2>We detected a login from another tab or device.</h2>
                    <button type="button" class="light-color link-no-underline blue--button pd-t10 pd-b10 pd-l20 pd-r20" (click)="logoutByEmail()">Logout from other Device</button>
                    <div class="or-divider mg-t30 mg-b30"><span>OR</span></div>
                    <button type="button" class="light-color link-no-underline blue--button pd-t10 pd-b10 pd-l20 pd-r20" (click)="isMultipleLogin =  false">Cancel</button>
                </div>
            </div>
            <div class="right-panel__form">
                <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" *ngIf="!isPasswordForgot && !isSSOPartner && !isMultipleLogin">
                    <div class="right-panel__form--group">
                        <input [ngClass]="{'has-value': email.value}" type="text" required="required" value=""
                            formControlName="email" type="email" id="inputEmail" required
                            placeholder="Enter your email" />
                            <label for="inputEmail" class="form__label">*</label>

                        <!-- <label for="input" class="control-label">Email*</label><i class="bar"></i> -->
                        <!-- <div *ngIf="loginForm.controls.email.dirty && loginForm.controls.email.errors" class="label-error"> -->
                        <div *ngIf="email?.invalid && (email?.dirty || email?.touched)" class="label-error">
                            <span class="errror--class">{{ getErrorMessage("email") }}</span>
                        </div>
                        <div *ngIf="email?.errors?.isEmailExists && email?.invalid && (email?.dirty || email?.touched)">
                            <span class="errror--class"> This email does not have a upGrad Enterprise account. Try with another
                                email
                                or reach out for <a href="https://programs.harappa.education/hc/en-us">help</a></span>
                        </div>
                    </div>
                    <div class="right-panel__form--group has-error">
                        <span id="password--status" class="password--icon cursor-pointer"
                            [ngClass]="{'icon-eye-blocked': !passwordText, 'icon-eye': passwordText}"
                            (click)="togglePassword()"></span>
                        <!-- <span id="password--status" class="password--icon icon-eye-blocked" onClick="viewPassword()" ></span> -->
                        <input [ngClass]="{'has-value': password.value}" formControlName="password"
                            type="{{!passwordText ? 'password' : 'text'}}" required="required" value=""
                            id="password-field" minlength="8" placeholder="Enter your shared password" />
                            <label for="password-field" class="form__label">*</label> 
                               <div *ngIf="password?.errors?.required && (password?.dirty || password?.touched)"  class="label-error">
                                    <span class="errror--class">Password is required</span>
                                </div>

                                <div *ngIf="password?.errors?.minlength "  class="label-error">
                                    <span class="errror--class">Password must be at least 8 characters.</span>
                                </div>
                                <div *ngIf="error" class="label-error">
                                    <span class="errror--class">{{error}}</span>
                                </div>
                                <!-- <span class="errror--class">Password doesn't matched.</span> -->
                                <span class="confirm--class d-none">Password matched.</span>
                        <div class="right-panel__bottom d-flex mg-b30">
                            <div class="right-panel__bottom--left">
                            
                            </div>
                            <div class="right-panel__bottom--right">
                                <a (click)="forgotPassword(true)" class="forgot--pw">Forgot Password?</a>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex align-items-start button-container">
                        <div class="form--terms-text">By continuing, you are agreeing to the
                            <!-- <span (click)="showTCModal(true)">Terms & Conditions, Privacy policy and Cookies policy*</span>. -->
                            <a href="https://harappa.education/terms-and-conditions/" target="_blank">&nbsp;Terms & Conditions</a>,
                            <a href="https://harappa.education/privacy-policy/" target="_blank">Privacy policy</a> and 
                            <a href="https://harappa.education/cookie-policy/" target="_blank">Cookies policy</a>&nbsp;of the Company.
                        </div>
                        <button type="button"
                            class="light-color link-no-underline blue--button pd-t10 pd-b10 pd-l20 pd-r20"
                            type="submit">Login</button>
                        <div class="or-divider mg-t30 mg-b30"><span>OR</span></div>
                        <button (click)="SSOSignIn()" type="button"
                            class="light-color link-no-underline blue--button pd-t10 pd-b10 pd-l20 pd-r20">Sign in with
                            sso</button>
                        <a href="https://programs.harappa.education/hc/en-us" class="btn-link">Need help?</a>
                    </div>
                    <div class="text-center" *ngIf="otherUserErr"><span class="errror--class">You are not registered for
                            this course. Please sign in <a (click)="navigateToMainSite()" class="cursor-pointer"
                                [routerLink]="">here</a></span></div>

                </form>
                <form [formGroup]="loginForm" *ngIf="isPasswordForgot">
                    <div class="right-panel__form--group">
                        <input formControlName="email" [value]="emailpatchValue" #email type="text" required="required"
                            value="" type="email" required [ngClass]="{'has-value': email.value}"
                            placeholder="Enter your email">
                        <!-- <label for="input" class="control-label">Email*</label><i class="bar"></i> -->
                        <div *ngIf="loginForm.controls.email.dirty && loginForm.controls.email.errors"
                            class="label-error">
                            <!-- <div *ngIf="email?.invalid && (email?.dirty || email?.touched)" class="label-error"> -->
                            <span class="errror--class">{{ getErrorMessage("email") }}</span>
                        </div>
                        <div *ngIf="email?.errors?.isEmailExists && email?.invalid && (email?.dirty || email?.touched)">
                            <span class="errror--class"> This email does not have a upGrad Enterprise account. Try with another
                                email
                                or reach out for <a href="https://programs.harappa.education/hc/en-us">help</a></span>
                        </div>
                    </div>
                    <div class="d-flex align-items-start button-container">
                        <button type="button"
                            class="light-color link-no-underline blue--button pd-t10 pd-b10 pd-l20 pd-r20" type="submit"
                            (click)="resendPassword(email.value)"><span>send link</span></button>
                        <a (click)="forgotPassword(false)" class="button-container--back mg-t30">
                            <span class="icon-angle-left"></span>
                            Back to login home</a>
                        <!-- <a href="https://programs.harappa.education/hc/en-us" class="btn-link">Need help?</a> -->
                    </div>
                    <div class="text-center" *ngIf="otherUserErr"><span class="errror--class">You are not registered for
                            this course. Please sign in <a (click)="navigateToMainSite()" class="cursor-pointer"
                                [routerLink]="">here</a></span></div>

                </form>
                <form [formGroup]="ssoForm" *ngIf="isSSOPartner">
                    <div class="right-panel__form--group">
                        <input formControlName="SSOId" #SSOId (keyup)="tocaps()" type="text" required="required"
                            value="" type="SSOId" required [ngClass]="{'has-value': SSOId.value}" placeholder="SSO company ID">
                        <!-- <label for="input" class="control-label">Enter your email</label><i class="bar"></i> -->
                        <div *ngIf="ssoForm.controls.SSOId.dirty && ssoForm.controls.SSOId.errors" class="label-error">
                            <!-- <div *ngIf="email?.invalid && (email?.dirty || email?.touched)" class="label-error"> -->
                            <span class="errror--class">{{ getErrorMessageSSO("SSOId") }}</span>
                        </div>
                        <!-- <div *ngIf="SSOId?.invalid && (SSOId?.dirty || SSOId?.touched)">
                            <span class="errror--class">  <a href="https://programs.harappa.education/hc/en-us">help</a></span>
                        </div> -->
                    </div>
                    <div class="d-flex align-items-start button-container">
                        <div class="form--terms-text">By continuing, you are agreeing to the
                            <!-- <span (click)="showTCModal(true)">Terms & Conditions, Privacy policy and Cookies policy*</span>. -->
                            <a href="https://harappa.education/terms-and-conditions/" target="_blank">&nbsp;Terms & Conditions</a>,
                            <a href="https://harappa.education/privacy-policy/" target="_blank">Privacy policy</a> and 
                            <a href="https://harappa.education/cookie-policy/" target="_blank">Cookies policy</a>&nbsp;of the Company.
                        </div>
                        <button type="button"
                            class="light-color link-no-underline blue--button pd-t10 pd-b10 pd-l20 pd-r20" type="submit"
                            (click)="SSOSignInCall()"><span>Continue</span></button>
                        <a (click)="forgotPassword(false)" class="button-container--back mg-t30"><span class="icon-angle-left"></span>
                            Back to login home</a>
                        <!-- <a href="https://programs.harappa.education/hc/en-us" class="btn-link">Need help?</a> -->
                    </div>
                    <div class="text-center" *ngIf="otherUserErr"><span class="errror--class">You are not registered for
                            this course. Please sign in <a (click)="navigateToMainSite()" class="cursor-pointer"
                                [routerLink]="">here</a></span></div>

                </form>
            </div>
        </section>
    </div>
</div>
